module.exports = __webpack_public_path__ + "dimer/static/img/AliciaLi.6169f4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AliciaLi.jpg
// module id = EKVl
// module chunks = 0